import React from 'react';
import TableCustomHeadItem from "@ui/tableCustom/head/item/TableCustomHeadItem";
import {mapperColumnCbType} from "@ui/tableCustom/types/table";
import {
    IExportMutateContext,
    IExportParamsContext
} from "@containers/export/containers/buildData/hooks/types/exportParams";
import {IQueryParamsContext} from "@hooks/query/types/queryParams";
import {IColumnItem} from "@ui/tableCustom/types/columns";


interface IProps<T> {
    column: IColumnItem<T>,
    exportParams: IExportParamsContext<T>,
    exportMutate: IExportMutateContext<T>,
    mapperColumnCb?: mapperColumnCbType<T>,
    params: IQueryParamsContext<T>,
    index: number,
    globalIndex?: number
}

function CurrentColumn<T>({
                              column,
                              mapperColumnCb,
                              exportMutate,
                              exportParams,
                              params,
                              globalIndex,
                              index,
                          }: IProps<T>) {

    if(column.hideUi){
        return  <></>
    }
    if (mapperColumnCb) {
        return mapperColumnCb({
            exportMutate,
            exportParams,
            column,
            index,
            order: params.order,
            setOrder: params.setOrder,
            setDirection: params.setDirection,
            direction: params.direction,
            globalIndex,
        })
    }
    return <TableCustomHeadItem
        <T>
        exportMutate={exportMutate}
        exportParams={exportParams}
        column={column}
        order={params.order}
        direction={params.direction}
        setDirection={params.setDirection}
        setOrder={params.setOrder}
        globalIndex={globalIndex}
    />
};

export default CurrentColumn;